import { useState } from "react";
import styles from "./style.module.scss";
import PropType from "prop-types";

const Header = ({ setAddNewCreditz }) => {
  return (
    <div className={styles.mainComponent}>
      <button
        className={`${styles.button}`}
        onClick={() => setAddNewCreditz("CreateNewCreditz")}
      >
        Add Creditz
      </button>
    </div>
  );
};

Header.propTypes = {
  publishActive: PropType.bool,
  setAddNewCreditz: PropType.func,
};

Header.defaultProps = {
  setAddNewCreditz: () => {
  },
};

export default Header;
